import React, {useEffect, useState} from 'react'
import {Box, Typography} from '@mui/material'

interface ContextWindowBarProps {
  contextTokens: number
  contextWindow: number
  compacted: boolean
}

// Matches the backend COMPACTION_THRESHOLD — the point at which auto-compact triggers
const COMPACTION_THRESHOLD = 0.6

const ContextWindowBar: React.FC<ContextWindowBarProps> = ({contextTokens, contextWindow, compacted}) => {
  const [showCompactedNotice, setShowCompactedNotice] = useState(false)

  useEffect(() => {
    if (compacted) {
      setShowCompactedNotice(true)
      const timer = setTimeout(() => setShowCompactedNotice(false), 4000)
      return () => clearTimeout(timer)
    }
  }, [compacted])

  const compactionBudget = contextWindow * COMPACTION_THRESHOLD
  const headroom = Math.max(0, Math.round(((compactionBudget - contextTokens) / compactionBudget) * 100))

  const headroomColour =
    headroom > 60 ? 'success.main' :
    headroom > 30 ? 'warning.main' :
    'error.main'

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 2,
        borderBottom: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        flexShrink: 0,
        minHeight: 32
      }}
    >
      <Typography variant="caption" color="text.disabled">
        {contextTokens.toLocaleString()} tokens used
      </Typography>

      {showCompactedNotice ? (
        <Typography variant="caption" sx={{color: 'warning.main', fontWeight: 500}}>
          Auto-compacted ✓
        </Typography>
      ) : (
        <Typography variant="caption" sx={{color: headroomColour}}>
          Context left until auto-compact: {headroom}%
        </Typography>
      )}
    </Box>
  )
}

export default ContextWindowBar
